import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginAuth {
  login(credentials: LoginCredentials): Observable<unknown>;
  isAuthenticated(): boolean;
  beginSso(returnUrl: string): boolean;
}

export interface LoginConfig {
  forgotPasswordUrl: string;
  createAccountUrl: string;
  drupalSiteUrl: string;
}

export const LOGIN_AUTH = new InjectionToken<LoginAuth>('LOGIN_AUTH');
export const LOGIN_CONFIG = new InjectionToken<LoginConfig>('LOGIN_CONFIG');
export const AUTH_API_ROOT = new InjectionToken<string>('AUTH_API_ROOT');
export const DRUPAL_SITE_URL = new InjectionToken<string>('DRUPAL_SITE_URL');
